namespace RioERP.Reports {
    export interface OrderShippingItemsReportForm {
        OrdershippingBooksId: Serenity.IntegerEditor;
        OrderId: Serenity.LookupEditor;
        OrderNumber: Serenity.StringEditor;
        SourceType: Serenity.EnumEditor;
        ProductName: Serenity.StringEditor;
        BookName: Serenity.StringEditor;
        Quantity: Serenity.IntegerEditor;
        PendriveType: Serenity.StringEditor;
        ShippingProviderName: Serenity.StringEditor;
        TrackingId: Serenity.StringEditor;
        TrackingUrl: Serenity.StringEditor;
        ProductId: Serenity.IntegerEditor;
        ProductBookid: Serenity.LookupEditor;
        PenDriveTypeId: Serenity.LookupEditor;
        ShippingProviderId: Serenity.LookupEditor;
    }

    export class OrderShippingItemsReportForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.OrderShippingItemsReport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderShippingItemsReportForm.init)  {
                OrderShippingItemsReportForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.EnumEditor;

                Q.initFormType(OrderShippingItemsReportForm, [
                    'OrdershippingBooksId', w0,
                    'OrderId', w1,
                    'OrderNumber', w2,
                    'SourceType', w3,
                    'ProductName', w2,
                    'BookName', w2,
                    'Quantity', w0,
                    'PendriveType', w2,
                    'ShippingProviderName', w2,
                    'TrackingId', w2,
                    'TrackingUrl', w2,
                    'ProductId', w0,
                    'ProductBookid', w1,
                    'PenDriveTypeId', w1,
                    'ShippingProviderId', w1
                ]);
            }
        }
    }
}
